import api from './api';

export const paymentService = {
  pingWebhook: async () => {
    console.log('pinging webhook');
    try {
      const response = await api.post('/payments/webhook', {});
      console.log(response.data);
      return response.data;
    } catch (error) {
      console.error('Error ping webhook:', error);
      throw error;
    }
  },

  getSubscription: async () => {
    console.log('getting sub');
    try {
      const response = await api.get('/payments/get-sub');
      console.log(response.data);
      return response.data;
    } catch (error) {
      console.error('Error getting subscription:', error);
      throw error;
    }
  },

  deleteSubscription: async () => {
    console.log('deleting sub');
    try {
      const response = await api.post('/payments/cancel-sub', {});
      console.log(response.data);
      return response.data;
    } catch (error) {
      console.error('Error deleting subscription:', error);
      throw error;
    }
  },

  isSubscriptionActive: async () => {
    console.log('getting sub status');
    try {
      const response = await api.get('/payments/is-sub-active');
      console.log(response.data);
      return response.data;
    } catch (error) {
      console.error('Error getting user sub status:', error.response?.status, error);
      throw error;
    }
  }
};